import { render, staticRenderFns } from "./mobile-register-addr.vue?vue&type=template&id=060b8357&scoped=true&"
import script from "./mobile-register-addr.vue?vue&type=script&lang=js&"
export * from "./mobile-register-addr.vue?vue&type=script&lang=js&"
import style0 from "./mobile-register-addr.vue?vue&type=style&index=0&id=060b8357&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b8357",
  null
  
)

export default component.exports